import { extractEmailsFromString } from "../helpers";
import { EmailsList } from "../types";

export const getUnsubscribedContactEmailsMap = (unsubscribedContactEmails: string[]): Record<string, boolean> => {
  if (!unsubscribedContactEmails || !Array.isArray(unsubscribedContactEmails)) {
    return {};
  }
  const map = new Map<string, boolean>();
  for (const email of unsubscribedContactEmails) {
    map.set(email, true);
  }
  return Object.fromEntries(map);
};

export const parseEmail = (input: string): EmailsList => {
  // Extract emails from the pasted text
  return extractEmailsFromString(input.trim());
};
